import { Link } from "react-router-dom";

export const Footer = () => {
	return (
		<footer className='bg-text-tertiary text-white font-[arial]'>
			<div className='mx-auto flex w-full max-w-7xl flex-col gap-10 px-6 py-10 sm:px-10 lg:gap-14 lg:px-16'>
				<div className='flex w-full flex-row items-start justify-between gap-6'>
					<div className='w-1/2 text-center sm:text-left'>
						<h3 className='font-semibold'>Empresa</h3>
						<ul id='Empresa' className='mt-4 list-none text-sm space-y-2'>
							<li className='mb-1'>
								<Link to='/acerca' className='hover:underline'>
									Acerca de Nosotros
								</Link>
							</li>
							<li className='mb-1'>
								<Link to='/' className='hover:underline'>
									Servicios
								</Link>
							</li>
						</ul>
					</div>

					<div className='w-1/2 text-center sm:text-left'>
						<h3 className='font-semibold'>Recursos</h3>
						<ul id='Recursos' className='mt-4 list-none text-sm space-y-2'>
							<li className='mb-1'>
								<Link to='/faq' className='hover:underline'>
									Preguntas frecuentes
								</Link>
							</li>
							<li className='mb-1'>
								<Link to='/contacto' className='hover:underline'>
									Contacto
								</Link>
							</li>
						</ul>
					</div>
				</div>
				<div className='flex w-full flex-row items-start justify-between gap-6'>
					<div className='w-1/2 text-center sm:text-left'>
						<h3 className='font-semibold'>Clientes</h3>
						<ul id='Clientes' className='mt-4 list-none text-sm space-y-2'>
<li className='mb-1'>
								<Link to='/como-funciona' className='hover:underline'>
									Cómo funciona
								</Link>
							</li>
							<li className='mb-1'>
								<Link to='/manuales' className='hover:underline'>
									Manuales
								</Link>
							</li>
						</ul>
					</div>

					<div className='w-1/2 text-center sm:text-left'>
						<h3 className='font-semibold'>Legal</h3>
						<ul id='Legal' className='mt-4 list-none text-sm space-y-2'>
							<li className='mb-1'>
								<Link to='/politicas' className='hover:underline'>
									Políticas
								</Link>
							</li>
							<li className='mb-1'>
								<Link
									to='/terminos-condiciones'
									className='hover:underline'
								>
									Términos y Condiciones
								</Link>
							</li>
							<li className='mb-1'>
								<Link to='/politicas-cookies' className='hover:underline'>
									Políticas de cookies
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>

			{/* Linea horizontal gris mas claro */}
			<div className='border-t border-[#6D6F73] px-4 py-5 sm:px-6 lg:px-16'>
				<div className='mx-auto grid max-w-7xl grid-cols-1 items-center gap-6 md:grid-cols-3 md:gap-4'>
					{/* 1. Izquierda: Imagen (Logo) + Nueva Imagen */}
					<div className='flex items-center justify-center gap-4 md:justify-start'>
						<img
							src='/servix_certificate.svg'
							className='h-10 w-10 object-contain sm:h-12 sm:w-12'
							alt='Descripción de la imagen extra'
						/>

						<img
							src='/Servix_Isologo_White.svg'
							className='h-10 w-auto sm:h-12'
							alt='Servix Logo'
						/>
					</div>

					{/* 2. Centro: Texto */}
					<p className='text-center text-xs text-white/85 sm:text-sm'>
						&copy; 2026 Servix
					</p>

					{/* 3. Derecha: Redes Sociales */}
					<div className='flex justify-center gap-3 md:justify-end'>
						<img
							className='h-6 w-6 sm:h-7 sm:w-7'
							src='/instagram_logo.svg'
							alt='Instagram Logo'
						/>
						<img
							className='h-6 w-6 sm:h-7 sm:w-7'
							src='/whatsapp_logo.svg'
							alt='WhatsApp Logo'
						/>
					</div>
				</div>
			</div>
		</footer>
	);
};
